import React, { Fragment, type PropsWithChildren } from 'react';
import styled from 'styled-components';

import type { SpacesObject } from '@wecasa/common/src/components/with-separators/type';
import { getMarginsFromSpacesObject } from '@wecasa/common/src/components/with-separators/utils';
import type { StyledProps } from '@wecasa/common/src/types/helpers';

import Separator, { type SeparatorProps } from './separator';

export type WithSeparatorsProps = PropsWithChildren<{}> &
  SeparatorProps & {
    spaces?: SpacesObject;
  };

const StyledSeparator = styled(Separator)<StyledProps<WithSeparatorsProps, 'spaces'>>`
  ${({ $spaces }) => ($spaces ? `margin: ${getMarginsFromSpacesObject($spaces)}` : '')}
`;

const WithSeparators = ({ children, spaces, ...rest }: WithSeparatorsProps) => (
  <>
    {React.Children.toArray(children)
      .filter(React.isValidElement)
      .map((child, index) => (
        <Fragment key={child.key}>
          {index > 0 && <StyledSeparator $spaces={spaces} {...rest} />}
          {child}
        </Fragment>
      ))}
  </>
);

export default WithSeparators;
